import React, { useState } from 'react';

function FAQs() {
  const [expandedQuestion, setExpandedQuestion] = useState(null);

  const toggleQuestion = (question) => {
    setExpandedQuestion(expandedQuestion === question ? null : question);
  };

  return (
    <div className="bg-background-secondary-color rounded-lg p-6 font-popins lg:m-[100px] mt-5">
      <h2 className="text-3xl font-extrabold text-btn-color mb-10">Frequently Asked Questions</h2>
      <div className="space-y-8 max-w-4xl">
        {faqData.map((faq, index) => (
          <div key={index} className="flex flex-col">
            <div className="flex items-center cursor-pointer" onClick={() => toggleQuestion(index)}>
              <div className="flex-shrink-0">
                <svg
                  className={`h-6 w-6 text-btn-color transform transition-transform duration-300 ${expandedQuestion === index ? 'rotate-180' : ''
                    }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path strokeLinecap="round" strokeWidth="round" d="M5 13l4 4L19 7"></path>
                </svg>
              </div>
              <h3 className="text-xl  font-semibold text-gray-100 ml-4">{faq.question}</h3>
            </div>
            {expandedQuestion === index && (
              <div className="ml-10 mt-4 flex justify-center items-center  max-w-7xl">
                <p className="text-sm text-gray-300  text-white max-w-7xl">{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

const faqData = [
  {
    question: 'What is FinzAid.com?',
    answer: (
      <ul className='list-disc leading-relaxed'>
        <li className=' font-poppins text-md text-gray-300'>FinzAid.com is a comprehensive platform that offers free financial education, trading resources, and insights into the financial markets. Our mission is to empower traders and financial enthusiasts with up-to-date knowledge to help them succeed in the world of finance and trading.</li>
      </ul>
    )

  },
  {
    question: 'How do I create an account on FinzAid.com?',
    answer: (
      <div className='font-poppins'>
        <h1><strong className='text-xl text-gray-300'>Account Registration Procedure</strong></h1>
        <br></br>
        <p><strong className='text-lg text-gray-300'>Step 1: Account Registration</strong></p>
        <br></br>
        <ul className='list-disc leading-relaxed'>
          <li className='text-md text-gray-300'>Access the Registration Page: Navigate to the registration page on our website.</li>
          <li className='text-md text-gray-300'>Fill in the Registration Form:</li>
          <ul className='list-disc leading-relaxed'>
            <li className='text-md text-gray-300'>Name: Enter your full name.</li>
            <li className='text-md text-gray-300'>Telephone: Enter a valid phone number (include country code).</li>
            <li className='text-md text-gray-300'>Email: Enter a valid email address (this will be used for account verification).</li>
            <li className='text-md text-gray-300'>Password: Create a strong password (minimum 8 characters, including uppercase, lowercase, numbers, and special characters).</li>
          </ul>
          <li className='text-md text-gray-300'>Submit the Registration Form: Click the "Register" button to create your account. You will see a confirmation message indicating that your account has been created successfully.</li>
          <br></br>
          <figure className="flex flex-col items-center">
            <img src="/img/regi.png" alt="registration form" className="w-full h-auto" />
            <figcaption className="text-gray-400 text-sm mt-2">
              registration page
            </figcaption>
          </figure>
        </ul>
        <br></br>


        <p><strong className='text-lg text-gray-300'>Step 2: Email Verification</strong></p>
        <br></br>
        <ul className='list-disc leading-relaxed'>
          <li className='text-md text-gray-300'>Check Your Email: Visit your email inbox and look for a verification email from us. If you don’t see the email, check your spam or junk folder.</li>
          <li className='text-md text-gray-300'>Fill Out the KYC Form: Open the verification email and click on the provided link to access the KYC form. Complete the KYC form by filling in the required personal details (such as address, identification number, etc.).</li>
          <li className='text-md text-gray-300'>Submit the KYC Form: Once you have filled in all the necessary details, submit the form. You will receive a confirmation message indicating that your KYC submission was successful.(After successful submission, your personal information will be deleted from our database.)</li>
          <br></br>
          <figure className="flex flex-col items-center">
            <img src="/img/kyc-mail.png" alt="kyc-mail" className="w-full h-auto" />
            <figcaption className="text-gray-400 text-sm mt-2">
              KYC email
            </figcaption>
          </figure>
        </ul>
        <br></br>

        <p><strong className='text-lg text-gray-300'>Step 3: Account Verification</strong></p>
        <br></br>
        <ul className='list-disc leading-relaxed'>
          <li className='text-md text-gray-300'>Wait for Verification: After submitting the KYC form, your account will be under review. This process typically takes around 40 minutes.</li>
          <li className='text-md text-gray-300'>Receive Verification Email: If your account is verified, you will receive an email confirming your verification status. If there are any issues, you may receive a message explaining the reason for the rejection.</li>
          <br></br>
          <figure className="flex flex-col items-center">
            <img src="/img/verify-mail.jpg" alt="verify-mail" className="w-full h-auto" />
            <figcaption className="text-gray-400 text-sm mt-2">
              Verification email
            </figcaption>
          </figure>

        </ul >
        <br></br>


        <p><strong className='text-lg text-gray-300'>Step 4: Logging Into Your Account</strong></p>
        <br></br>
        <ul className='list-disc leading-relaxed'>
          <li className='text-md text-gray-300'>Log In to Your Account: Return to the login page on our website. Enter your registered email and password, then click the "Log In" button.</li>
          <li className='text-md text-gray-300'>Handle Rejection Cases: If your account is rejected, you will see a message indicating that you are already a user on our website. We filter duplicate accounts to maintain security and integrity.</li>
        </ul>
      </div>
    ),
  },

  {
    question: 'Do I need to complete KYC to access the content?',
    answer: (
      <ul className='list-disc leading-relaxed'>
        <li className=' font-poppins text-md text-gray-300'>Yes, to ensure security and compliance, all users must complete a Know Your Customer (KYC) verification process before accessing our content. Once you register for a session, we will send you a KYC verification link. Once your identity is verified, you will gain access to our educational content and trading sessions.</li>
      </ul>
    )
  },
  {
    question: 'Can I view past session videos?',
    answer: (
      <ul className='list-disc leading-relaxed'>
        <li className=' font-poppins text-md text-gray-300'>Yes, once you are a verified user, you will have access to past session recordings. These videos are available in our "Trading Resources" section. You can watch these at your own pace to enhance your learning experience.</li>
      </ul>
    )
  },
  {
    question: 'Are there any fees for the trading sessions?',
    answer: (
      <ul className='list-disc leading-relaxed'>
        <li className=' font-poppins text-md text-gray-300'>No, FinzAid.com offers all trading sessions and educational content free of charge. We believe in providing accessible financial education to everyone without any fees or hidden costs.</li>
      </ul>
    )
  },
  {
    question: 'How do I know if I am registered successfully?',
    answer: (
      <ul className='list-disc leading-relaxed'>
        <li className=' font-poppins text-md text-gray-300'>After registering for a session, you will receive a confirmation email containing a link to complete the KYC process. Once your KYC verification is approved, you will receive further instructions on how to access the session.</li>
      </ul>
    )
  },
  {
    question: 'Is my data safe with FinzAid?',
    answer: (
      <ul className='list-disc leading-relaxed'>
        <li className=' font-poppins text-md text-gray-300'>Yes, at FinzAid, we prioritize your privacy and data security. We use advanced encryption protocols and comply with all legal requirements to ensure that your personal and financial information is secure. Please refer to our Privacy Policy for more details.</li>
      </ul>
    )
  },
  {
    question: 'Can I attend multiple sessions?',
    answer: (
      <ul className='list-disc leading-relaxed'>
        <li className=' font-poppins text-md text-gray-300'>Yes, once you are a verified user, you can attend as many sessions as you like. There are no restrictions, and all sessions are free to access for our registered and verified users.</li>
      </ul>
    )
  },
  {
    question: 'How can I contact customer support?',
    answer: (
      <ul className='list-disc leading-relaxed'>
        <li className=' font-poppins text-md text-gray-300'>You can contact our customer support team by emailing support@finzaid.com or by using the contact form on our "Contact Us" page. We are here to assist you with any queries or issues you may have.</li>
      </ul>
    )
  },
  {
    question: 'What if I forget to complete my KYC after registering?',
    answer: (
      <ul className='list-disc leading-relaxed'>
        <li className=' font-poppins text-md text-gray-300'>If you forget to complete your KYC after registration, don’t worry. We will send you reminders via email. However, please note that you will not be able to access the sessions or content until the KYC process is complete.</li>
      </ul>
    )
  },

];


export default FAQs;
